import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import {fetchUsers} from '../actions/user'
import User from '../components/User'
import {changeFilterDatas} from '../actions/filter'

const mapStateToProps = state => {
  const { user } = state
  const {
    isFetching,
    lastUpdated,
    items,
    totalRows
  } = user || {
    isFetching: true,
    items: []
  }

  return {
    items,
    isFetching,
    lastUpdated,
    totalRows,
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getUsers: fetchUsers,
      changeFilterDatas:changeFilterDatas,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(User)
